import React from 'react';
import { List, Empty } from 'antd';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import BookingRow from 'components/booking-row';

import './style.css';

const getProfile = ({ userKey, user }) => {
  if (userKey === 'worker') return `/worker-detail/${user}`;
  if (userKey === 'userId') return `/employer-detail/${user}`;
  return '/404';
};

const BookingList = ({ bookings, className, userKey, header }) => {
  const customClassName = classNames('booking-list', className);

  return (
    <List
      header={header}
      className={customClassName}
      size="small"
      bordered
      split
    >
      {bookings.map((doc) => {
        const data = doc.data();
        const user = data[userKey];
        const profile = getProfile({ userKey, user });
        return (
          <BookingRow
            key={doc.id}
            booking={{ id: doc.id, ...data }}
            user={user}
            profile={profile}
          />
        );
      })}
      {bookings.length < 1 ? <Empty description="No upcoming shifts" /> : null}
    </List>
  );
};

BookingList.propTypes = {
  header: PropTypes.node,
  className: PropTypes.string,
  bookings: PropTypes.arrayOf(
    PropTypes.shape({
      startDate: PropTypes.string,
      rate: PropTypes.number,
    })
  ).isRequired,
  userKey: PropTypes.string.isRequired,
};
BookingList.defaultProps = {
  header: null,
  className: null,
};

export default BookingList;
